<div class="edit-product-page" dir="rtl">
  <div class="page-header">
    <div>
      <h1>تحديث المنتج</h1>
      <p>قم بتعديل بيانات المنتج، الأسعار، المخزون، والتصنيفات.</p>
    </div>

    <div class="header-actions">
      <button type="button" class="btn ghost" (click)="onCancel()">رجوع</button>

      <button type="button" class="btn light" (click)="onReset()" [disabled]="isLoading() || isSaving()">
        إعادة تحميل
      </button>
    </div>
  </div>

  @if (isLoading()) {
  <div class="state-card">
    جاري تحميل البيانات...
  </div>
  }

  @if (errorMessage()) {
  <div class="alert alert-error">
    {{ errorMessage() }}
  </div>
  }

  @if (!isLoading()) {
  <form [formGroup]="productForm" class="product-card" novalidate>
    <div class="tabs">
      @for (tab of tabs; track tab.key) {
      <button type="button" [class.active]="activeTab() === tab.key" (click)="setActiveTab(tab.key)">
        <span>{{ tab.labelAr }}</span>
        <small>{{ tab.labelEn }}</small>
      </button>
      }
    </div>

    <!-- BASIC -->
    @if (activeTab() === 'basic') {
    <section class="tab-body">
      <div class="section-title">
        <h2>البيانات الأساسية</h2>
        <p>اختيار التصنيف، البراند، وبيانات الاسم والوصف.</p>
      </div>

      <div class="grid two">
        <div class="form-group">
          <label>نوع التصنيف *</label>

          <select formControlName="sourceType">
            @for (source of sources; track source.id) {
            <option [ngValue]="source.id">
              {{ source.name }}
            </option>
            }
          </select>
        </div>

        <div class="form-group" [class.invalid]="isDropdownInvalid('mainCategoryId')">
          <label>الفئة الرئيسية *</label>

          <ng-multiselect-dropdown [placeholder]="'اختر الفئة الرئيسية'" [settings]="singleDropdownSettings"
            [data]="mainCategories()" [formControl]="mainCategoryControl" (onSelect)="onMainCategorySelect($event)"
            (onDeSelect)="onMainCategoryDeSelect()">
          </ng-multiselect-dropdown>

          @if (isDropdownInvalid('mainCategoryId')) {
          <small class="error">
            الفئة الرئيسية مطلوبة
          </small>
          }
        </div>
      </div>

      <div class="grid two">
        <div class="form-group">
          <label>الفئات الفرعية</label>

          <ng-multiselect-dropdown [placeholder]="'اختر الفئات الفرعية'" [settings]="multiDropdownSettings"
            [data]="subCategories()" [formControl]="subCategoryControl">
          </ng-multiselect-dropdown>

          <small class="hint">يمكن اختيار أكثر من فئة فرعية.</small>
        </div>

        <div class="form-group" [class.invalid]="isDropdownInvalid('brandId')">
          <label>البراند *</label>

          <ng-multiselect-dropdown [placeholder]="'اختر البراند'" [settings]="singleDropdownSettings" [data]="brands()"
            [formControl]="brandControl">
          </ng-multiselect-dropdown>

          @if (isDropdownInvalid('brandId')) {
          <small class="error">
            البراند مطلوب
          </small>
          }
        </div>
      </div>

      <div class="grid three">
        <div class="form-group">
          <label>Parent ID</label>
          <input type="number" formControlName="parentId" placeholder="اختياري" />
        </div>

        <div class="form-group">
          <label>عدد المبيعات</label>
          <input type="number" formControlName="numOfSale" min="0" />
        </div>

        <div class="switch-card">
          <div class="switch-info">
            <div class="switch-icon">
              <i class="fas fa-check-circle"></i>
            </div>
            <div>
              <label class="switch-label">الحالة</label>
              <small>تفعيل أو إيقاف ظهور المنتج</small>
            </div>
          </div>

          <label class="switch modern-switch">
            <input type="checkbox" formControlName="status" />
            <span></span>
          </label>
        </div>

        <div class="switch-card">
          <div class="switch-info">
            <div class="switch-icon">
              <i class="fas fa-fire"></i>
            </div>
            <div>
              <label class="switch-label">الأفضل مبيعًا</label>
              <small>تمييز المنتج ضمن المنتجات الأكثر مبيعًا</small>
            </div>
          </div>

          <label class="switch modern-switch">
            <input type="checkbox" formControlName="isBestSeller" />
            <span></span>
          </label>
        </div>
      </div>

      <div class="grid three">
        <div class="form-group" [class.invalid]="isFieldInvalid('storeId')">
          <label>المتجر *</label>

          <select formControlName="storeId">
            @for (store of stores(); track store.id) {
            <option [ngValue]="store.id">
              {{ store.name }}
            </option>
            }
          </select>

          @if (isFieldInvalid('storeId')) {
          <small class="error">
            {{ getFieldError('storeId') }}
          </small>
          }
        </div>
      </div>

      <div class="language-box">
        <h3>الاسم والوصف</h3>

        <div class="grid two">
          <div class="form-group" [class.invalid]="isFieldInvalid('arName')">
            <label>اسم المنتج بالعربي *</label>

            <input type="text" formControlName="arName" placeholder="مثال: حلواني مربى فراولة" />

            @if (isFieldInvalid('arName')) {
            <small class="error">
              {{ getFieldError('arName') }}
            </small>
            }
          </div>

          <div class="form-group" [class.invalid]="isFieldInvalid('enName')">
            <label>Product Name English *</label>

            <input type="text" formControlName="enName" placeholder="Example: Strawberry Jam" />

            @if (isFieldInvalid('enName')) {
            <small class="error">
              {{ getFieldError('enName') }}
            </small>
            }
          </div>
        </div>

        <div class="grid two">
          <div class="form-group">
            <label>الوصف بالعربي</label>
            <textarea formControlName="arDescription" rows="4"></textarea>
          </div>

          <div class="form-group">
            <label>Description English</label>
            <textarea formControlName="enDescription" rows="4"></textarea>
          </div>
        </div>
      </div>

      <div class="flags">
        <label>
          <input type="checkbox" formControlName="published" />
          منشور
        </label>

        <label>
          <input type="checkbox" formControlName="approved" />
          معتمد
        </label>

        <label>
          <input type="checkbox" formControlName="isFeatured" />
          منتج مميز
        </label>

        <label>
          <input type="checkbox" formControlName="isTodaysDeal" />
          عرض اليوم
        </label>
      </div>
    </section>
    }

    <!-- PRICE -->
    @if (activeTab() === 'price') {
    <section class="tab-body">
      <div class="section-title">
        <h2>السعر والمخزون</h2>
        <p>تعديل الأسعار، SKU، الباركود، وكميات المخزون.</p>
      </div>

      <div class="grid two">
        <!-- purchasePrice: غير مطلوب -->
        <div class="form-group">
          <label>سعر الشراء</label>
          <input type="number" formControlName="purchasePrice" step="any" placeholder="اختياري" />
        </div>

        <div class="form-group" [class.invalid]="isFieldInvalid('sellingPrice')">
          <label>سعر البيع *</label>
          <input type="number" formControlName="sellingPrice" min="0" step="0.01" />
          @if (isFieldInvalid('sellingPrice')) {
          <small class="error">{{ getFieldError('sellingPrice') }}</small>
          }
        </div>
      </div>

      <div class="grid two">
        <!-- SKU: غير مطلوب -->
        <div class="form-group">
          <label>SKU</label>
          <input type="text" formControlName="sku" placeholder="اختياري" />
        </div>

        <div class="form-group" [class.invalid]="isFieldInvalid('barcode')">
          <label>Barcode *</label>
          <input type="text" formControlName="barcode" />
          @if (isFieldInvalid('barcode')) {
          <small class="error">{{ getFieldError('barcode') }}</small>
          }
        </div>
      </div>

      <div class="grid three">
        <div class="form-group" [class.invalid]="isFieldInvalid('unitId')">
          <label>الوحدة *</label>
          <select formControlName="unitId">
            <option [ngValue]="null">اختر الوحدة</option>
            @for (unit of units(); track unit.id) {
            <option [ngValue]="unit.id.toString()">{{ unit.name }}</option>
            }
          </select>
          @if (isFieldInvalid('unitId')) {
          <small class="error">{{ getFieldError('unitId') }}</small>
          }
        </div>

        <div class="form-group" [class.invalid]="isFieldInvalid('unitFactor')">
          <label>Unit Factor *</label>
          <input type="text" formControlName="unitFactor" />
          @if (isFieldInvalid('unitFactor')) {
          <small class="error">{{ getFieldError('unitFactor') }}</small>
          }
        </div>

        <div class="form-group" [class.invalid]="isFieldInvalid('barcodeType')">
          <label>Barcode Type *</label>
          <input type="text" formControlName="barcodeType" />
          @if (isFieldInvalid('barcodeType')) {
          <small class="error">{{ getFieldError('barcodeType') }}</small>
          }
        </div>
      </div>

      <div class="grid three">
        <div class="form-group" [class.invalid]="isFieldInvalid('discount')">
          <label>الخصم</label>
          <div class="percent-input">
            <input type="text" formControlName="discount" placeholder="0" min="0" max="100" />
            <span>%</span>
          </div>
          @if (isFieldInvalid('discount')) {
          <small class="error">{{ getFieldError('discount') }}</small>
          }
        </div>

        <!-- maxPurchaseQty: غير مطلوب، يقبل كسور -->
        <div class="form-group">
          <label>أقصي كمية شراء</label>
          <input type="number" formControlName="maxPurchaseQty" step="any" placeholder="اختياري" />
        </div>

        <!-- minPurchaseQty: غير مطلوب، يقبل كسور -->
        <div class="form-group">
          <label>أقل كمية شراء</label>
          <input type="number" formControlName="minPurchaseQty" step="any" placeholder="اختياري" />
        </div>
      </div>

      <div class="grid two">
        <div class="form-group" [class.invalid]="isFieldInvalid('weightKg')">
          <label>الوزن بالكيلو</label>
          <input type="number" formControlName="weightKg" min="0" step="0.125" />
          @if (isFieldInvalid('weightKg')) {
          <small class="error">{{ getFieldError('weightKg') }}</small>
          }
        </div>
      </div>

      <!-- Switch Card: السماح بالمخزون السالب -->
      <div class="switch-card" style="margin-bottom: 20px;">
        <div class="switch-info">
          <div class="switch-icon">
            <i class="fas fa-arrow-down"></i>
          </div>
          <div>
            <label class="switch-label">السماح بالمخزون السالب</label>
            <small>يسمح للكمية بالهبوط تحت الصفر عند البيع</small>
          </div>
        </div>
        <label class="switch modern-switch">
          <input type="checkbox" formControlName="isNegativeStockEnable" />
          <span></span>
        </label>
      </div>

      <div class="stock-section">
        <div class="stock-header">
          <div>
            <h3>المخزون</h3>
            <p>كل متجر يظهر مرة واحدة فقط.</p>
          </div>

          <button type="button" class="btn add" (click)="addStock()">
            + إضافة مخزن
          </button>
        </div>

        <div formArrayName="stocks" class="stock-list">
          @for (stock of stocks.controls; track stock; let i = $index) {
          <div class="stock-row" [formGroupName]="i">
            <div class="form-group">
              <label>المتجر</label>
              <select formControlName="storeId">
                @for (store of stores(); track store.id) {
                <option [ngValue]="store.id">{{ store.name }}</option>
                }
              </select>
            </div>

            <div class="form-group">
              <label>الكمية</label>
              <input type="number" formControlName="quantity" min="0" />
            </div>

            <div class="form-group">
              <label>السعر</label>
              <input type="number" formControlName="price" min="0" step="0.01" />
            </div>

            <button type="button" class="btn danger" (click)="removeStock(i)" [disabled]="stocks.length <= 1">
              حذف
            </button>
          </div>
          }
        </div>
      </div>
    </section>
    }

    <!-- MEDIA -->
    @if (activeTab() === 'media') {
    <section class="tab-body">
      <div class="section-title">
        <h2>الوسائط والتهيئة</h2>
        <p>تعديل الـ Variant، slug، ومعرفات الصور المحفوظة.</p>
      </div>

      <div class="grid two">
        <div class="form-group">
          <label>Variant</label>
          <select formControlName="variantId">
            <option [ngValue]="null">اختر المتغير</option>
            @for (variant of variants(); track variant.id) {
            <option [ngValue]="variant.id">{{ variant.name }}</option>
            }
          </select>
        </div>

        <div class="form-group">
          <label>Slug</label>
          <input type="text" formControlName="slug" placeholder="product-name" />
        </div>
      </div>

      <div class="form-group photos-picker">
        <label>صور المنتج</label>

        <div class="selected-photos-box">
          @if (selectedPhotos().length > 0) {
          <div class="selected-photos">
            @for (photo of selectedPhotos(); track photo.id) {
            <div class="selected-photo-card">
              <img [src]="photo.url | ImageUrlPipe" alt="product photo" appImageFallback />
              <button type="button" class="remove-photo-btn" (click)="removeSelectedPhoto(photo)">×</button>
            </div>
            }
          </div>
          } @else {
          <div class="empty-photos">لم يتم اختيار صور بعد</div>
          }

          <button type="button" class="btn-open-gallery" (click)="openGalleryModal()">
            اختيار من الجالري
          </button>
        </div>

        <input type="hidden" formControlName="photosIdsText" />
      </div>

      @if (isGalleryModalOpen()) {
      <div class="gallery-modal-backdrop">
        <div class="gallery-modal">
          <div class="gallery-modal-header">
            <h3>اختيار الصور</h3>
            <button type="button" class="close-modal-btn" (click)="closeGalleryModal()">×</button>
          </div>
          <div class="gallery-modal-body">
            <app-gallery-picker [selectedImages]="selectedPhotos()"
              (selectedImagesChange)="onGalleryImagesChange($event)"></app-gallery-picker>
          </div>
          <div class="gallery-modal-footer">
            <button type="button" class="btn-cancel" (click)="closeGalleryModal()">إغلاق</button>
          </div>
        </div>
      </div>
      }
    </section>
    }

    <div class="form-footer">
      <div>
        <button type="button" class="btn ghost" (click)="previousTab()" [disabled]="isFirstTab() || isSaving()">
          السابق
        </button>

        <button type="button" class="btn ghost" (click)="nextTab()" [disabled]="isLastTab() || isSaving()">
          التالي
        </button>
      </div>

      <div>
        <button type="button" class="btn light" (click)="onCancel()" [disabled]="isSaving()">
          إلغاء
        </button>

        <button type="button" class="btn primary" (click)="onSubmit()" [disabled]="isSaving()">
          {{ isSaving() ? 'جاري الحفظ...' : 'حفظ التعديلات' }}
        </button>
      </div>
    </div>
  </form>
  }
</div>